import URI from 'urijs';

export function isFacebookImageExpired(imageUrl) {
    const queries = URI.parseQuery(imageUrl);
    const hex = queries["oe"];
    const unix = parseInt(hex, 16) * 1000;
    return unix < Date.now();
}
